
import dynamic from 'next/dynamic';
import { client, urlFor } from "../lib/client";

const Counter = dynamic(() => import('@/src/components/Counter'), {
  ssr: false,
});
import Layout from "@/src/layout/Layout";
import { sliderProps } from "@/src/sliderProps";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { NextSeo, ArticleJsonLd } from 'next-seo';
import { Fragment } from 'react';

const About = ({aboutPageData, fHeaderMenuData, seo}) => {

  const {  
    aboutFirstSectionData,
    aboutSecondSectionData,
    aboutThirdSectionData,
    aboutFourthSectionData,
    aboutFifthSectionData,
    teamMemberSectionData,
    statisticsSectionData,
    fetchFooter,
    testimonialsSectionData,
    fetchHeader } = aboutPageData


    const {canonical, jsonLtd, metaDescription, metaTitle, seo_image, type, url } = seo

  return (
    <Fragment>

<NextSeo
            title={metaTitle}
            description={metaDescription}
            canonical={canonical}
            robots="index, follow"
            openGraph={{
              type: type,
              url: url,
              image: urlFor(seo_image).url(),
            }} 
            additionalLinkTags={[
              {
                rel: 'icon',
                href: '/assets/images/favicon.png',
              },
              {
                rel: 'apple-touch-icon',
                href: 'https://www.test.ie/touch-icon-ipad.jpg',
                sizes: '76x76'
              },
             ]}
        />
        <ArticleJsonLd
     dataArray={JSON?.parse(jsonLtd)}
        />


{/* redischeckcommit */}
    <Layout footerData={fetchFooter} menuData={fHeaderMenuData} headerData={fetchHeader}>
      {/* Page Banner Section Start */}
      <section
        className="page-banner pt-210 rpt-150 pb-45 rpb-50 rel z-1"
        style={{ backgroundImage: "url(assets/images/hero/hero-two-bg.png)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-10 col-lg-11">
              <h2 className="hero-title mb-100 rmb-50 wow fadeInUp delay-0-2s">
               {aboutFirstSectionData.aboutFirstHeading}
                <img
                  className="mxw-20"
                  src={aboutFirstSectionData.aboutFirstTextImage.convertedImageData.image.img}
                  alt={aboutFirstSectionData.aboutFirstTextImage.convertedImageData.image.alt}
                />
                <img
                  className="mxw-20"
                  src={aboutFirstSectionData.aboutSecondTextImage.convertedImageData.image.img}
                  alt={aboutFirstSectionData.aboutSecondTextImage.convertedImageData.image.alt}
                />
               {aboutFirstSectionData.aboutSecondHeading}
                <span className="arrow">
                  <img
                    className="wow fadeInLeft delay-0-6s"
                    src="/assets/images/hero/title-arrow.png"
                    alt="Arrow"
                  />
                </span>
              </h2>
            </div>
          </div>
        </div>
      </section>

      {/* Page Banner Section End */}
      {/* Video Area start */}
      <div className="video-area-two rel z-1">
        <div className="container-fluid">
          <div className="video-part style-two mb-40 wow fadeInUp delay-0-2s">
            <img src={aboutSecondSectionData.aboutSecondVideoThumbnail
.convertedImageData.image.img} alt={aboutSecondSectionData.aboutSecondVideoThumbnail
  .convertedImageData.image.alt} />
            <a
              href={aboutSecondSectionData
                .aboutSecondvideoUrl}
              className="mfp-iframe video-play"
            >
              <i className="fas fa-play" />
            </a>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 wow fadeInLeft delay-0-2s">
              <div className="client-text text-lg-start text-center mt-40 pb-50">
               {aboutThirdSectionData.aboutThirdParagraph
}
              </div>
              <div className="row">
                <div className="col-xl-10">
                 
                </div>
              </div>
            </div>
            <div className="col-lg-6 wow fadeInRight delay-0-2s">
              <div className="video-year text-lg-end text-center rel">
               {aboutThirdSectionData.aboutThirdStartDate}
                <img
                  className="leaf-shape-custom"
                  src={aboutThirdSectionData.aboutThirdHeroImage.convertedImageData.image.img}
                  alt="Leaf"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Video Area end */}
      {/* Who We Are start */}
      <section className="who-we-are-area pt-100 rpt-80 pb-75 rpb-45 rel z-1">
        <div className="container container-1290">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="section-title text-center mb-70 wow fadeInUp delay-0-2s">
                <span className="sub-title mb-15"> 
                {aboutFourthSectionData.aboutFourthHeading}
                 </span>
                <h2> {aboutFourthSectionData.aboutFourthMainHeading}  </h2>
              </div>
            </div>
          </div>
          <div className="row gap-90">
            {aboutFourthSectionData.aboutFourthItems.map((item,index) => (
     <div key={index} className="col-lg-4 col-md-6">
     <div className={`why-choose-item style-two wow fadeInUp ${item.delay}`}>
       <div className="why-choose-header">
         <i className={item.flat_icon} />
         <h3> {item.name} </h3>
       </div>
       <p>
       {item.paragraphs}
       </p>
     </div>
   </div>
            ) )}

          </div>
        </div>
      </section>
      {/* Who We Are end */}
      {/* Headline area start */}
      <div className="headline-area bgc-primary pt-80 pb-65">
        <div className="container-fluid">
          <div className="headline-wrap marquee">
            <span>
              {aboutFourthSectionData.aboutFourthHeadlineItems.map((item, index) => (
  <span key={index} className="marquee-item">
  <i className={item.icon} />
  <b> {item.name} </b>
</span>
              ))}
            
          
            </span>
          </div>
        </div>
      </div>
      {/* Headline Area end */}
      {/* Team Area start */}
      <section className="team-area pt-130 rpt-100">
        <div className="container-fluid">
          <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 justify-content-center">

            {teamMemberSectionData.map((item, index) => (
        <div key={index} className="col">
        <div className={`team-member wow fadeInUp delay-0-${2+index}s`}>
          <div className="image">
            <img src={item.image.url} alt="Team Member" />
          </div>
          <div style={{  cursor: 'pointer'  }} className="contents">
            <h3> {item.title} </h3>
            <span>  {item.designation} </span>
            {/* <Link legacyBehavior href={`/team-member/${item.slug.current}`}>
              <a className="read-more">
                <i className="far fa-arrow-right" />
              </a>
            </Link> */}
          </div>
          {/* <div className="btn-social">
          <Link legacyBehavior href={`/team-member/${item.slug.current}`}>
              <a className="read-more">
                <span>View Details</span>{" "}
                <i className="far fa-arrow-right" />
              </a>
            </Link>
           
          </div> */}
        </div>
      </div>
            ))}
  
          </div>
        </div>
      </section>
      {/* Team Area end */}
      {/* Statistics Area start */}
      <div
        className="statistics-area pt-100 rpt-70 rel z-1"
        style={{ backgroundImage: "url(assets/images/hero/hero-two-bg.png)" }}
      >
        <div className="container">
          <div className="row justify-content-between">
            {statisticsSectionData.map((item,index) => (
              <div key={index} className="col-xl-2 col-lg-3 col-6">
              <div className={`counter-item counter-text-wrap wow fadeInRight delay-0-${2+index}s`}>
                <i className="fal fa-check-circle" />
                <Counter end={item.end} extraClass={item?.extraClass} />
                <span className="counter-title"> {item.name} </span>
              </div>
            </div>
            ))}

          </div>
        </div>
      </div>
      {/* Statistics Area end */}
      {/* Testimonial Area start */}
      <section className="testimonial-section pt-70 rpt-30">
        <div className="container container-1210">
          <div className="row">
            
            <div className="col-lg-6">
              <div className="image-border-shape rmb-20 wow fadeInRight delay-0-2s">
                <img
                  src={testimonialsSectionData.testimonialsHeroImage.image}
                  alt={testimonialsSectionData.testimonialsHeroImage.alt}
                />
                <div className="bottom-border" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="testimonial-one-right-part wow fadeInLeft delay-0-2s">
                <Swiper
                  {...sliderProps.testimonialsActiveSwiper}
                  className="testimonials-active"
                >
                  {testimonialsSectionData.testimonialsSectionItems.map((item, index) => (
                     <SwiperSlide key={index} className="testimonial-item">
                     <div className="author-speech">
                       <p>
                         <span className="quote">“</span> {item.review}
                         <span className="quote right-quote">“</span>
                       </p>
                     </div>
                     <div className="testimonial-footer">
                       <div className="testimonial-author">
                         <div className="author-image">
                           <img
                             src={item.image.url}
                             alt={item.image.alt}
                           />
                         </div>
                         <div className="author-info">
                           <h4> {item.client_name} </h4>
                           <span className="designation">  {item.designation} </span>
                         </div>
                       </div>
                       <div className="ratting style-two">
  {Array.from({ length: Math.floor(item.rating) }, (_, index) => (
    <i key={index} className="fas fa-star" />
  ))}
  {item.rating % 1 !== 0 && (
    <i className="fas fa-star-half-alt" />
  )}
</div>
                     </div>
                   </SwiperSlide>

                  )) }

                </Swiper>
                <div className="testimonial-controls mt-75 rmt-40">
                  <button className="testimonial-prev slick-arrow">
                    <i className="far fa-chevron-left" />
                  </button>
                  <div className="testimonial-dots">
                    <div className="slick-dots"></div>
                  </div>
                  <button className="testimonial-next slick-arrow">
                    <i className="far fa-chevron-right" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonial Area end */}
      {/* Client Logo Two start */}
      <section className="client-logo-area pt-130 rpt-100 pb-100 rpb-70">
        <div className="container">
          <div className="section-title text-center mb-60">
            <h4> {aboutFifthSectionData.aboutFifthSectionHeading} </h4>
          </div>
          <div className="client-logo-wrap">
            {aboutFifthSectionData.aboutFifthSectionItems.map((item, index) => (
  <Link key={index} legacyBehavior href="/contact">
  <a className={`client-logo-item wow fadeInUp delay-0-${2+index}s`}>
    <img
      src={item.image.url}
      alt={item.image.alt}
    />
  </a>
</Link>
            ))}
          
          
          </div>
        </div>
      </section>
    </Layout>
    </Fragment>
  );
};

export const getServerSideProps = async () => {

  const query = `*[ _type == "aboutUs"]{
    ...,
    "teamMemberData": pageBuilder.teamMembers[]->{
      title,
      designation,
      slug,
      member_image,
      socials,
    },
  }[0]`;
  const aboutPage = await client.fetch(query);


  // fetching-layout

    // fetching layouts
    const queryForFooter = `*[ _type == "Footer"  ][0]`;
    const fetchFooter = await client.fetch(queryForFooter);
  
    const queryForHeader = `*[ _type == "Header"  ][0]`;
    const fetchHeader = await client.fetch(queryForHeader);

  const {pageBuilder, seo,
  teamMemberData
  } = aboutPage;


  const { aboutFirstSection,
    aboutFourthSection,
    aboutSecondSection,
    aboutThirdSection,
    aboutFifthSection,
    testimonials_section,
    statistic,
  } = pageBuilder


  const transformData = (data) => {
    const transformData = data;
    const convertImage = urlFor(transformData).url();
    const convertedImageData = {
      image: { alt: transformData.alt, img: convertImage },
    };
    const convertedData = { convertedImageData };
    return convertedData;
  };

  const transformDataArray = (data) => {
    return data.map((item) => {
      const imageUrlConverted = urlFor(item
        ).url();
      return {
        image: {
          url: imageUrlConverted,
          alt: item.alt,
        },
      };
    });
  };

  const transformDataFifthArray = (data) => {
    return data.map((item) => {
      const imageUrlConverted = urlFor(item
        ).url();
      return {
        ...item,
        image: {
          url: imageUrlConverted,
          alt: item.alt,
        },
      };
    });
  };

  const transformMembersArray = (data) => {
    return data.map((item) => {
      const imageUrlConverted = urlFor(item.member_image
        ).url();
      return {
        ...item,
        image: {
          url: imageUrlConverted,
          alt: item.member_image.alt,
        },
      };
    });
  };

  const transformTestimonialsArray = (data) => {
    return data.map((item) => {
      const imageUrlConverted = urlFor(item.right_side_image
        ).url();
        const hero_imageUrlConverted = urlFor(item.right_side_image
          ).url();
      return {
        ...item,
        image: {
          url: imageUrlConverted,
          alt: item.right_side_image,
        },
        hero_image: {
          url: hero_imageUrlConverted,
          alt: item.right_side_image,
        },
      };
    });
  };

  

  // about-section-first
  const aboutFirstHeading = aboutFirstSection.first_text;
  const aboutSecondHeading = aboutFirstSection.second_text;
  const aboutFirstTextImage = transformData(aboutFirstSection.hero_text_image);
  const aboutSecondTextImage = transformData(aboutFirstSection.hero_text_image_second);
  const aboutFirstSectionData = {aboutFirstHeading, aboutSecondHeading, aboutFirstTextImage, aboutSecondTextImage } ; 

  // about-section-second
  const aboutSecondVideoThumbnail = transformData(aboutSecondSection.video_thumbnail);
  const aboutSecondvideoUrl = aboutSecondSection.video_url;
  const aboutSecondSectionData = {aboutSecondVideoThumbnail, aboutSecondvideoUrl  } ;


  // about-section-third
  const aboutThirdHeroImage = transformData(aboutThirdSection.hero_image);
  const aboutThirdParagraph = aboutThirdSection.paragraph;
  const aboutThirdStartDate = aboutThirdSection.start_date;
  const aboutThirdShowCaseImages = transformDataArray(aboutThirdSection.showCaseImages);
  const aboutThirdSectionData = { aboutThirdHeroImage,aboutThirdParagraph, aboutThirdStartDate, aboutThirdStartDate, aboutThirdShowCaseImages }


  // about-section-fourth
  const aboutFourthHeading = aboutFourthSection.heading;
  const aboutFourthMainHeading = aboutFourthSection.main_Heading;
  const aboutFourthItems = aboutFourthSection.services_items;
  const aboutFourthHeadlineItems = aboutFourthSection.headline_items;
  const aboutFourthSectionData = {
    aboutFourthHeading,
    aboutFourthMainHeading,
    aboutFourthItems,
    aboutFourthHeadlineItems
  }

  // about-section-fifth
  // const aboutFifthHeading = aboutFifthSection.heading;
  // const aboutFifthItems = transformDataArray(aboutFifthSection.services_items);
  // const aboutFifthSectionData = {aboutFifthHeading,aboutFifthItems }

  // team-member-section
  const teamMemberSectionData = transformMembersArray(teamMemberData)


  // statistics section
  const statisticsSectionData = statistic.statistics

  // testimonials section
  const testimonialsSectionItems = transformTestimonialsArray(testimonials_section.testimonials.services_items);
  const testimonialsHeroImage = 
  {
   image: urlFor(testimonials_section.testimonials_hero_image).url(),
   alt: testimonials_section.testimonials_hero_image.alt
  }
  const testimonialsSectionData = {
    testimonialsHeroImage,
    testimonialsSectionItems
  }

  // about-fifth section
  const aboutFifthSectionHeading = aboutFifthSection.heading;
  const aboutFifthSectionItems = transformDataFifthArray(aboutFifthSection.services_items);
const aboutFifthSectionData = {
  aboutFifthSectionHeading,aboutFifthSectionItems
}



  // fetching header data



          // fetching header data
          const headMenuData = `*[ _type == "Header"  ]{
            menu_items[]->{
                     title,
                     slug,
                     menu_name,
                     menu_name_number,
           }
         }[0]`;
          const fHeaderMenuData =  await client.fetch(headMenuData);
          const headerDataForMenu = fHeaderMenuData.menu_items;

  const aboutPageData = {
    aboutFirstSectionData,
    aboutSecondSectionData,
    aboutThirdSectionData,
    aboutFourthSectionData,
    aboutFifthSectionData,
    statisticsSectionData,
    fetchFooter,
    fetchHeader,
    pageBuilder,
    teamMemberSectionData,
    testimonialsSectionData,
    
  }

  return {
    props: {
      aboutPageData,
      teamMemberData,
      fHeaderMenuData: headerDataForMenu,
      seo
    }

  }

}
export default About;
